import classes from './Horeca.module.scss'
import React, { useEffect } from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, { IQuestion } from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp';
import { Link } from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const Horeca = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
            
    const title = t('horeca.title')
    const description = t('horeca.text', {returnObjects: true})

    const blackBlocks = t('horeca.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('horeca.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('horeca.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('horeca.benefitBlocks', {returnObjects: true})

    const stories = t('horeca.stories', {returnObjects: true})



    const useCaseText = t('horeca.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('horeca.Faq.left', {returnObjects: true}),
        right: t('horeca.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    HORECA IT Solutions & Hospitality Management Software | Goteco
                </title>
                <meta
                    name="description"
                    content="Enhance hotel and restaurant operations with integrated HORECA IT solutions. Automate reservations, POS, and inventory management while improving guest experience."
                />
                <link rel="canonical" href="https://go-te.co/industries/horeca" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={700} />

            <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                <div>
                    <h3>{t('horeca.blackBlocksTitle')}</h3>
                    <p>{t('horeca.blackBlocksText')}</p>
                    <p>{t('horeca.blackBlocksText2')}</p>
                </div>
                <div className={classes.blocks}>
                    {blackBlocks.map(({ text, icon }) => (<BlackCardWithIcon key={icon} iconName={icon} text={text} />))}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                <div>
                    <h2>{t('horeca.challengesBlocksTitle')}</h2>
                </div>
                <div>
                    {challengesBlocks.map(({ icon, text, title }) => <GrayCardBlueIcon iconName={icon} title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('horeca.solutionsBlocksTitle')}</h2>
                </div>
                <div>
                    {solutionsBlocks.map(({ image, title, text }) => <div className={classes.block} key={title}>
                        <img alt={title} src={require(`./media/${image}`)} />
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('horeca.benefitBlocksTitle')}</h2>
                    <p>{t('horeca.benefitBlocksText')}</p>
                </div>
                <div>
                    {benefitBlocks.map(({ title, text }) => <BlueGradientBlock title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={"section--dark-gray " + classes['stories']}>
                <h2>{t('horeca.storiesTitle')}</h2>
                <div className={classes.blocks}>
                    {stories.map(({ title, text }) => <GrayCardWithVerticalDivider title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('horeca.useCase')}</h2>
                        <div className={classes.text}>
                            <img src={eRoadImg} alt="HORECA use case" />
                            <p>{useCaseText}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('horeca.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>
                            {t('horeca.useCaseButton')}
                        </Link>
                    </div>
                </div>
                <img className={classes.img} src={eRoadImg} alt="HORECA system" />
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard
                    title={t('horeca.formCard.title')}
                    message={t('horeca.formCard.message')}
                    buttonText={t('horeca.formCard.buttonText')}
                    labels={t('horeca.formCard.labels', {returnObjects: true})}
                    top={3} id='contact' />
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('horeca.Faq.title')} questions={questions} />
            </section>
        </main>
        </>
    );
};

export default Horeca;